import http from "../httpService";
import {getBaseUrl} from "../../config";

;

export const registerService = data => {
  return http.post(
    `${getBaseUrl()}/register`,
    data
  );
};